export enum LocalState {
    IDLE,
    REST,
    SHUFFLING,
    BETTING,
    DEALING,
    RESULT,
    TIE,
    PLAYER,
    BANKER,
    PLAYER_A,
    PLAYER_B,
    ROUND_CANCEL,
    FREE_SPIN,
}

export const LocalStateStringKey = [
    'game.idle',
    'game.rest',
    'game.shuffling',
    '',
    'game.dealing',
];
